// extracted by mini-css-extract-plugin
export var shake = "_s-0";